import { call, put, takeLatest, delay, select } from 'redux-saga/effects';

import {
	createInvoice,
	createInvoiceFailure,
	createInvoiceSuccess,
	getInvoiceById,
	getInvoiceByIdFailure,
	getInvoiceByIdSuccess,
} from '.';

import invoiceService from '../../../services/InvoiceService';
import { getInvoices } from '../subscriptions';

function* rootSaga() {
	yield takeLatest(createInvoice, createInvoiceSaga);
	yield takeLatest(getInvoiceById, getInvoiceByIdSaga);
}

function* createInvoiceSaga({ payload }) {
	try {
		yield delay(300);
		const createdInvoice = yield call(invoiceService.create, payload);
		yield put(createInvoiceSuccess(createdInvoice));

		// reload invoices data in subscriptions
		const tableParams = yield select(({ subscriptions }) => subscriptions.invoices.tableParams);

		yield put(getInvoices({ ...tableParams, clientId: payload?.client?.id }));
	} catch (error) {
		yield put(createInvoiceFailure(error));
	}
}

function* getInvoiceByIdSaga({ payload }) {
	try {
		yield delay(300);
		const invoice = yield call(invoiceService.getById, payload);
		yield put(getInvoiceByIdSuccess(invoice));
	} catch (error) {
		yield put(getInvoiceByIdFailure(error));
	}
}

export default rootSaga;
